export const ROUTES = {
    home: '/',
    productDetails: '/product-details',
    shop: '/shop',
    contact: '/contact',
    checkout: '/checkout',
    MyOrders: '/my-orders',
    ProductByCategory: '/filtered-product',
    wishlist: '/wishlist',
    terms_conditioon: '/terms-condition',
    privacyPolicy: '/privacy-policy',
    aboutUs: '/about-us',
    refundPolicy: '/refund-policy',
    cancellationPolicy: '/ship-and-delivery-policy',
    paymentSuccess: '/payment-success',
    offers: '/offers',
    search: '/search',

}